import React from "react";
import { CloseCircle, Eye, EyeSlash } from "iconsax-reactjs";

import "./filter-drawer.css";
import Typography from "../Typography";

export default function FilterDrawer({
  isOpen,
  onClose,
  title = "Filtro",
  children,
  onApply,
  onClear,
  applyText = "Aplicar",
  clearText = "Limpar",
  isApplying = false,
}) {
  return (
    <div className={`filter-drawer-wrapper ${isOpen ? "open" : ""}`}>
      <div className="filter-drawer-overlay" onClick={onClose}></div>

      <aside className="filter-drawer-container">
        <header className="filter-drawer-header">
          <h2 className="filter-drawer-title">{title}</h2>
          <button
            className="filter-drawer-close-btn"
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseCircle variant="Outline" />
          </button>
        </header>

        <div className="filter-drawer-content">{children}</div>

        <footer className="filter-drawer-footer">
          <button
            className="filter-drawer-btn-apply"
            onClick={onApply}
            disabled={isApplying}
            style={{
              opacity: isApplying ? 0.7 : 1,
              cursor: isApplying ? "not-allowed" : "pointer",
            }}
          >
            <Typography.H6 color="white" weight={600}>
              {applyText}
            </Typography.H6>
          </button>
          <button className="filter-drawer-btn-clear" onClick={onClear}>
            <Typography.H6 color="white" weight={600}>
              {clearText}
            </Typography.H6>
          </button>
        </footer>
      </aside>
    </div>
  );
}
